var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPets(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.75a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zM9.25 5a2.75 2.75 0 115.5 0 2.75 2.75 0 01-5.5 0zM4 6.75a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zM1.25 8a2.75 2.75 0 115.5 0 2.75 2.75 0 01-5.5 0zM20 6.75a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zM17.25 8a2.75 2.75 0 115.5 0 2.75 2.75 0 01-5.5 0zM6.685 13.869c-1.208 1.238-1.933 2.836-2.362 4.242-.322 1.055.508 2.139 1.85 2.139h11.433c1.402 0 2.247-1.176 1.847-2.273-1.04-2.848-3.168-6.227-7.453-6.227-2.442 0-4.126.9-5.315 2.119zm-1.073-1.048C7.07 11.327 9.135 10.25 12 10.25c5.292 0 7.774 4.23 8.862 7.213.836 2.29-1.052 4.287-3.256 4.287H6.173c-2.104 0-3.969-1.835-3.285-4.077.467-1.53 1.286-3.378 2.724-4.852z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPets);
export default __webpack_public_path__ + "static/media/Pets.6101d938bbee2d25d4a1836b30e01736.svg";
export { ForwardRef as ReactComponent };